import { useEffect, useRef } from "react";
import { useAppSelector } from "@redux/hooks";
import { useToast } from "@shared-kernel/primary/shared/shadcn/ui/use-toast";
import { selectUserLogin } from "@user-management-context/write/application/use-cases/user-login/selectors/user-login-selectors";

// Mounted by App, not by the login screen: syncSession loads the profile before
// loginUser resolves, so LoginOutlet redirects — and unmounts LoginPage — before
// "success" is ever set. A notification owned by that page could therefore never
// be shown. App outlives the navigation, like the Toaster it sits next to.
export const useLoginNotifications = () => {
  const { toast } = useToast();
  const { processing } = useAppSelector(selectUserLogin);
  // Only report transitions seen while mounted. An outcome already in the store
  // belongs to an earlier visit and must stay silent — greeting someone with
  // "Bienvenu(e) !" as they land back on the login screen announces the opposite
  // of what just happened.
  const reportedOutcome = useRef(processing);

  useEffect(() => {
    if (processing === reportedOutcome.current) return;
    reportedOutcome.current = processing;

    if (processing === "success") {
      toast({ description: "Bienvenu(e) !" });
    } else if (processing === "failed") {
      toast({ description: "Mot de passe ou email invalide", variant: "destructive" });
    }
  }, [processing, toast]);
};
